import { ComponentType } from 'react'
import { AboutNav } from 'views/common/about-nav'
import { TextHero } from 'components/TextHero'
import { Intro } from './intro'
import { Map } from './map'

export const Contact: ComponentType = () => (
  <>
    <TextHero title="Conoce Mérida, Descubre Yucatán" subtitle="Contáctanos" />
    <AboutNav />
    <Intro />
    <Map />
  </>
)
